import { useDispatch, useSelector } from 'react-redux';
import * as $ from 'jquery';
import { labOrderEdit, labOrderLoad } from '../../../../../../redux/actions/order/labOrderActions';

export default function LabOrderButton(props) {
  const { resourceId, labOrderId, children } = props;
  const dispatch = useDispatch();
  const order = useSelector(state => state.order?.order);

  const eyeglasses = order?.eyeglasses || order?.eyeglasses_attributes || [];
  const contactLenses = order?.contact_lenses || order?.contact_lenses_attributes || [];
  const relatedItem = [...eyeglasses, ...contactLenses].find(item => item?.id === resourceId);

  const targetLabOrderId = labOrderId || relatedItem?.lab_order_id;

  const handleLabOrderOpen = () => {
    dispatch(labOrderEdit(resourceId));
    if (targetLabOrderId) {
      dispatch(labOrderLoad(targetLabOrderId, { include: '*', id: targetLabOrderId }));
    }
    $(`#labOrderForm-${resourceId}-modal`).modal();
  };

  return (
    <span className="pointer" onClick={handleLabOrderOpen}>
      {children}
    </span>
  );
}